import {
    CATCH_ALL_EVENT_TYPE,
    SALES_INSIGHTS_EVENT_TYPE,
    WEB_ENGAGEMENT_EVENT_TYPE,
} from './track-events/eventTypes';

export const orderPrefix = /^order_/i;

export const skuPrefix = /^SKU-/i;

export const productIdPrefix = /^P-/i;

export const underscorePattern = /_/i;

export const salesInsightsEventTypePattern = new RegExp(`\\.${SALES_INSIGHTS_EVENT_TYPE}\\.`, 'i');
export const webEngagementEventTypePattern = new RegExp(`\\.${WEB_ENGAGEMENT_EVENT_TYPE}\\.`, 'i');
export const catchAllEventTypePattern = new RegExp(`\\.${CATCH_ALL_EVENT_TYPE}\\.`, 'i');
